import { Link } from 'react-router-dom';

export default function Ingredients() {
  return (
    <section className="py-24 bg-[#FDF8F8] relative">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="relative h-[600px] order-2 lg:order-1">
            <img 
              src="https://static.readdy.ai/image/356e0a32a00e968a1405b9eb797d2bd9/d4b9666da706947ac7853e594d819e66.jpeg"
              alt="Fresh Ingredients"
              className="w-full h-full object-cover object-top rounded-sm"
            />
            <div className="absolute -top-6 -right-6 w-48 h-48 bg-[#C0392B]/6 rounded-sm -z-10"></div>
          </div>

          <div className="order-1 lg:order-2 space-y-6">
            <p className="text-xs tracking-[0.3em] text-[#C0392B] uppercase">Fresh &amp; Quality</p>
            <h2 className="text-4xl md:text-5xl font-light text-[#2D2D2D] leading-tight">
              Our Fresh and Seasonal Ingredients
            </h2>
            <div className="w-12 h-0.5 bg-[#C0392B]"></div>
            <p className="text-base text-[#666666] leading-relaxed">
              At Yummy Lab, we believe in using only the freshest and highest quality ingredients to create our dishes.&nbsp;
            </p>
            <p className="text-base text-[#666666] leading-relaxed">
              Our chefs carefully select and prepare each ingredient, ensuring that every dish is bursting with flavour and goodness.
            </p>

            <Link to="/about" className="mt-6 px-10 py-4 bg-[#C0392B] text-white text-sm tracking-wider hover:bg-[#A93226] transition-all duration-300 whitespace-nowrap cursor-pointer rounded-sm inline-block">
              About
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
